import { motion } from "framer-motion";
import { MapPin, User } from "lucide-react";
import { SectionHead } from "./Services";
import { useLanguage } from "../context/LanguageContext";

export default function About() {
  const { t, dir, lang } = useLanguage();
  const a = t.about;
  return (
    <section
      id="about"
      dir={dir}
      lang={lang}
      className="relative py-24 md:py-32 px-5 sm:px-8"
      data-testid="about-section"
    >
      <div className="mx-auto max-w-7xl grid gap-12 lg:grid-cols-12 items-start">
        <div className="lg:col-span-5">
          <SectionHead eyebrow={a.eyebrow} title={a.title} sub={a.sub} />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-7 relative rounded-2xl border border-white/10 bg-agency-gray p-6 sm:p-8 md:p-10"
          data-testid="founder-card"
        >
          <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 items-start">
            <div
              className="flex-shrink-0 h-24 w-24 sm:h-28 sm:w-28 rounded-2xl bg-gradient-to-br from-agency-gold/20 to-agency-purple/30 border border-agency-gold/30 flex items-center justify-center"
              data-testid="founder-photo-placeholder"
              aria-label="Founder photo placeholder"
            >
              <User size={40} className="text-agency-gold/70" />
            </div>
            <div className="flex-1">
              <h3 className="font-display text-2xl font-bold">
                {a.founderName}
              </h3>
              <p className="mt-1 text-xs uppercase tracking-[0.25em] text-agency-gold">
                {a.founderRole}
              </p>
              <div className="mt-4 space-y-3 text-sm sm:text-base text-white/65 leading-relaxed">
                {a.bioParagraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
              <div className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/50">
                <MapPin size={14} className="text-agency-gold" />
                {a.basedIn}
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-white/10">
            <p className="text-sm text-white/55 leading-relaxed">
              {a.studioLine}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
